import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustStats } from '../components/TrustStats';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { ServiceArea } from '../components/ServiceArea';
import { CTABanner } from '../components/CTABanner';
import { AlertTriangleIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function HomePage() {
  return <main data-id="element-325">
      <HeroSection data-id="element-326" />

      {/* Emergency Delivery Spotlight */}
      <section className="bg-red-600 text-white py-12 relative z-20" data-id="element-327">
        <div className="container mx-auto px-4" data-id="element-328">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-329">
            <div className="lg:w-1/2" data-id="element-330">
              <div className="flex items-center gap-3 mb-4" data-id="element-331">
                <AlertTriangleIcon className="h-8 w-8 text-red-200" data-id="element-332" />
                <h2 className="text-3xl font-bold" data-id="element-333">
                  Emergency Courier Drivers for Hire
                </h2>
              </div>
              <p className="text-red-100 text-lg leading-relaxed" data-id="element-334">
                Need a professional courier driver at short notice? We
                specialise in supplying experienced, vetted drivers you can hire
                on demand. Plus, we offer a full emergency item and parcel
                delivery service across the UK.
              </p>
            </div>
            <div className="lg:w-1/2 flex flex-col sm:flex-row gap-6" data-id="element-335">
              <div className="bg-white/10 p-6 rounded-xl border border-white/20 flex-1" data-id="element-336">
                <ClockIcon className="h-8 w-8 text-white mb-3" data-id="element-337" />
                <h3 className="font-bold text-xl mb-2" data-id="element-338">Drivers on Demand</h3>
                <p className="text-red-100 text-sm" data-id="element-339">
                  Hire a professional courier driver within hours, anywhere in
                  the UK.
                </p>
              </div>
              <div className="bg-white/10 p-6 rounded-xl border border-white/20 flex-1" data-id="element-340">
                <ShieldCheckIcon className="h-8 w-8 text-white mb-3" data-id="element-341" />
                <h3 className="font-bold text-xl mb-2" data-id="element-342">Item Delivery</h3>
                <p className="text-red-100 text-sm" data-id="element-343">
                  Same-day parcel and item delivery with dedicated vehicles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrustStats data-id="element-344" />
      <AboutSection data-id="element-345" />
      <ServicesSection data-id="element-346" />
      <WhyChooseUs data-id="element-347" />
      <Testimonials data-id="element-348" />
      <ServiceArea data-id="element-349" />
      <CTABanner data-id="element-350" />
    </main>;
}